export default __webpack_public_path__ + "static/media/cloudy.1f52b16e.svg";